import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import DatePicker from '../../../bronson/Datepicker';
import Input from '../../../bronson/Input';
import OpComercialFilter from './OpComercialFilter';
import usePermissions from 'hooks/usePermissions';

function ModalFilter(props) {
    const [productoComercial, setProductoComercial] = useState('');
    const [optSelectMarcaSelect, setoptSelectMarcaSelect] = useState([]);
    const [optSelectMarca, setoptSelectMarca] = useState([]);
    const [filtersAppliedModal, setFiltersAppliedModal] = useState([]);
    const [filtersLoad, setFiltersLoad] = useState(true);
    const { checkPermission } = usePermissions();

    useEffect(() => {
        let _optSelectMarca = [];
        props.optSelectMarca.forEach(element => {
            _optSelectMarca.push(
                <option value={element[1]} key={element[1]}>
                    {element[0]}
                </option>
            );
        });
        setoptSelectMarca(_optSelectMarca);
    }, [props.optSelectMarca]);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    useEffect(() => {
        setTimeout(setFiltersLoad(false), 1000);
        props.filtersApplied.forEach(element => {
            if (element.filterName === 'nif')
                document.getElementById('nif').value = element.value;
            else if (element.filterName === 'SellerContractsFullName')
                document.getElementById('SellerContractsFullName').value =
                    element.value;
            else if (element.filterName === 'matricula')
                document.getElementById('matricula').value = element.value;
            else if (element.filterName === 'fecha-ipo-desde')
                document.getElementById('fecha-ipo-desde').value =
                    element.value;
            else if (element.filterName === 'fecha-ipo-hasta')
                document.getElementById('fecha-ipo-hasta').value =
                    element.value;
            else if (element.filterName === 'fecha-venci-desde')
                document.getElementById('fecha-venci-desde').value =
                    element.value;
            else if (element.filterName === 'fecha-venci-hasta')
                document.getElementById('fecha-venci-hasta').value =
                    element.value;
            else if (element.filterName === 'UsuarioVendedorAsignado')
                document.getElementById('UsuarioVendedorAsignado').value =
                    element.value;
            else if (element.filterName === 'VehicleModelDescription')
                document.getElementById('VehicleModelDescription').value =
                    element.value;
            else if (element.filterName === 'Opefinanciera')
                document.getElementById('Opefinanciera').value = element.value;
            else if (element.filterName === 'bastidor')
                document.getElementById('bastidor').value = element.value;
            else if (element.filterName === 'MarcaSelected') {
                var optMarcarseclect = element.value.split(',');
                var prestatusSelect = [];
                props.optSelectMarca.forEach(elementopt => {
                    if (!optMarcarseclect.includes(elementopt[1]))
                        prestatusSelect.push(elementopt[1]);
                });
                setoptSelectMarcaSelect(prestatusSelect);
            }
        });
        setFiltersAppliedModal(
            JSON.parse(JSON.stringify(props.filtersApplied))
        );
    }, [props.filtersApplied]);

    useEffect(() => {
        if (productoComercial != undefined) onChangeFilter_ProductoComerial();
    }, [productoComercial]);

    function setFilterAply() {
        if (optSelectMarcaSelect.length > 0) {
            var _filtersAppliedModal = [];
            let update_temp = false;
            var valueToSend = '';
            props.optSelectMarca.forEach(_element => {
                optSelectMarcaSelect.forEach(element => {
                    if (parseInt(_element[1]) === parseInt(element))
                        update_temp = true;
                });
                if (!update_temp)
                    valueToSend +=
                        (valueToSend.length > 0 ? ',' : '') + _element[1];
                else update_temp = false;
            });
            update_temp = false;
            for (let element in filtersAppliedModal) {
                if (
                    filtersAppliedModal[element].filterName === 'MarcaSelected'
                ) {
                    // si el filtro ya existe, actualiza los valores del mismo.
                    _filtersAppliedModal.push({
                        filterName: 'MarcaSelected',
                        value: valueToSend,
                        filterServiceName: 'BrandCode',
                    });
                    update_temp = true;
                } else _filtersAppliedModal.push(filtersAppliedModal[element]);
            }
            if (!update_temp)
                // si el fltro no se agrego previamente, agrega el filtro al array..
                _filtersAppliedModal.push({
                    filterName: 'MarcaSelected',
                    value: valueToSend,
                    filterServiceName: 'BrandCode',
                });
            if (
                JSON.stringify(_filtersAppliedModal) !==
                JSON.stringify(props.filtersApplied)
            )
                props.setFiltersApplied(_filtersAppliedModal);
        } else if (
            JSON.stringify(filtersAppliedModal) !==
            JSON.stringify(props.filtersApplied)
        ) {
            props.setFiltersApplied(filtersAppliedModal);
        }

        props.setModalFilter(false);
    }
    function SHOW(element) {
        let elementTarget = document.getElementById(element);
        if (elementTarget.style.display === 'none') {
            document
                .getElementById(element + '_active')
                .classList.add('is-active');
            elementTarget.style.display = '';
        } else {
            document
                .getElementById(element + '_active')
                .classList.remove('is-active');
            elementTarget.style.display = 'none';
        }
    }

    const onChangeFilterTextDate = target => {
        try {
            var ChangeValid = target.target.value.split('/');
            if (ChangeValid.length === 3) onChangeFilter(target);
        } catch {}
    };
    const onChangeFilter = target => {
        if (filtersLoad) return;
        let filterName = '';
        let valueToSend = '';
        if (
            target &&
            target.currentTarget &&
            target.target &&
            (target.currentTarget.className.indexOf('input-div') !== -1 ||
                target.currentTarget.className.indexOf('c-input__input') !== -1)
        ) {
            filterName = target.target.id;
            valueToSend = target.target.value;
        } else {
            if (
                target &&
                target.className &&
                target.querySelector('input').value.length === 10 &&
                target.className.indexOf('datepicker') !== -1 &&
                target.querySelector('input')
            ) {
                filterName = target.querySelector('input').id;
                valueToSend = target.querySelector('input').value;
            } //asignacion por teclado sin enviar por enter.
            else if (target.target.value.length === 10) {
                filterName = target.target.id;
                valueToSend = target.target.value;
            }
            if (filterName !== '') {
                var fechaDesde = '';
                var fechaHasta = '';
                if (filterName === 'fecha-venci-desde') {
                    fechaDesde = valueToSend;
                    filtersAppliedModal.forEach(element => {
                        if (element.filterName === 'fecha-venci-hasta')
                            fechaHasta = element.value;
                    });
                } else if (filterName === 'fecha-venci-hasta') {
                    fechaHasta = valueToSend;
                    filtersAppliedModal.forEach(element => {
                        if (element.filterName === 'fecha-venci-desde')
                            fechaDesde = element.value;
                    });
                }
                if (fechaDesde !== '' && fechaDesde !== '') {
                    fechaDesde = fechaDesde.split('/');
                    fechaHasta = fechaHasta.split('/');

                    if (
                        fechaDesde[3] > fechaHasta[3] ||
                        (fechaDesde[2] === fechaHasta[2] &&
                            fechaDesde[1] > fechaHasta[1]) ||
                        (fechaDesde[2] === fechaHasta[2] &&
                            fechaDesde[1] === fechaHasta[1] &&
                            fechaDesde[0] > fechaHasta[0])
                    )
                        for (let i = 0; i < filtersAppliedModal.length; i++)
                            if (
                                filtersAppliedModal[i].filterName ===
                                'fecha-venci-hasta'
                            ) {
                                valueToSend =
                                    fechaDesde[0] +
                                    '/' +
                                    fechaDesde[1] +
                                    '/' +
                                    fechaDesde[2];
                                filtersAppliedModal[i].value =
                                    fechaDesde[0] +
                                    '/' +
                                    fechaDesde[1] +
                                    '/' +
                                    fechaDesde[2];
                                document.querySelector(
                                    '#fecha-venci-hasta'
                                ).value = valueToSend;
                                setFiltersAppliedModal(filtersAppliedModal);
                                break;
                            }
                }
            }
        }

        if (
            filtersAppliedModal !== null &&
            filtersAppliedModal !== undefined &&
            filterName !== ''
        ) {
            let filterServiceName = '';
            switch (filterName) {
                case 'VehicleModelDescription':
                    filterServiceName = 'VehicleModelDescription';
                    break;
                case 'UsuarioVendedorAsignado':
                    filterServiceName = 'UsuarioVendedorAsignado';
                    break;
                case 'Opefinanciera':
                    filterServiceName = 'FinancialOperationCode';
                    break;

                case 'fecha-venci-desde':
                    filterServiceName = 'ExpirationDateFrom';
                    break;

                case 'fecha-venci-hasta':
                    filterServiceName = 'ExpirationDateTo';
                    break;

                case 'fecha-ipo-desde':
                    filterServiceName = 'IPODateFrom';
                    break;

                case 'fecha-ipo-hasta':
                    filterServiceName = 'IPODateTo';
                    break;

                case 'nif':
                    filterServiceName = 'TitularNIF';
                    break;

                case 'matricula':
                    filterServiceName = 'VehiclePlate';
                    break;

                case 'SellerContractsFullName':
                    filterServiceName = 'SellerContractsFullName';
                    break;
                case 'bastidor':
                    filterServiceName = 'VehicleIdentificationNumber';
                    break;
            }

            let update_temp = false;
            for (let element in filtersAppliedModal) {
                if (filtersAppliedModal[element].filterName === filterName) {
                    // si el filtro ya existe, actualiza los valores del mismo.
                    filtersAppliedModal[element].value = valueToSend;
                    filtersAppliedModal[element]['filterServiceName'] =
                        filterServiceName;
                    update_temp = true;
                    break;
                }
            }
            if (!update_temp && filterName.length > 0)
                // si el fltro no se agrego previamente, agrega el filtro al array..
                filtersAppliedModal.push({
                    filterName: filterName,
                    value: valueToSend,
                    filterServiceName: filterServiceName,
                });
            setFiltersAppliedModal(filtersAppliedModal);
        }
    };
    const onChangeFilter_ProductoComerial = () => {
        if (filtersLoad) return;
        if (productoComercial !== '') {
            let filterServiceName = 'ProductCode';
            let valueToSend = productoComercial;
            let update_temp = false;

            for (let element in filtersAppliedModal) {
                if (
                    filtersAppliedModal[element].filterName ===
                    'Producto_comercial'
                ) {
                    // si el filtro ya existe, actualiza los valores del mismo.
                    if (valueToSend !== 'null') {
                        filtersAppliedModal[element].value = valueToSend; //parseInt(valueToSend)
                        filtersAppliedModal[element].filterServiceName =
                            'ProductCode';
                    } else filtersAppliedModal.splice(element, 1);
                    update_temp = true;
                    break;
                }
            }
            //si el fltro no se agrego previamente, agrega el filtro al array..
            if (!update_temp)
                filtersAppliedModal.push({
                    filterName: 'Producto_comercial',
                    value: valueToSend,
                    filterServiceName: filterServiceName,
                });
            setFiltersAppliedModal(filtersAppliedModal);
        } else {
            var newFilter = [];
            for (let element in filtersAppliedModal) {
                if (
                    filtersAppliedModal[element].filterName !==
                    'Producto_comercial'
                ) {
                    newFilter.push(filtersAppliedModal[element]);
                }
            }
            setFiltersAppliedModal(newFilter);
        }
    };

    const onChangeFilterfechaipohasta = target => {
        if (filtersLoad) return;

        var filterName = 'fecha-ipo-hasta';
        var valueToSend = target;
        var fechaDesde = '';
        var fechaHasta = target;

        filtersAppliedModal.forEach(element => {
            if (element.filterName === 'fecha-ipo-desde')
                fechaDesde = element.value;
        });

        if (fechaDesde !== '' && fechaHasta !== '') {
            fechaDesde = fechaDesde.split('/');
            fechaHasta = fechaHasta.split('/');
            if (
                fechaDesde[3] > fechaHasta[3] ||
                (fechaDesde[2] === fechaHasta[2] &&
                    fechaDesde[1] > fechaHasta[1]) ||
                (fechaDesde[2] === fechaHasta[2] &&
                    fechaDesde[1] === fechaHasta[1] &&
                    fechaDesde[0] > fechaHasta[0])
            ) {
                for (let i = 0; i < filtersAppliedModal.length; i++)
                    if (
                        filtersAppliedModal[i].filterName === 'fecha-ipo-hasta'
                    ) {
                        valueToSend =
                            fechaDesde[0] +
                            '/' +
                            fechaDesde[1] +
                            '/' +
                            fechaDesde[2];
                        filtersAppliedModal[i].value =
                            fechaDesde[0] +
                            '/' +
                            fechaDesde[1] +
                            '/' +
                            fechaDesde[2];
                        document.querySelector('#fecha-ipo-hasta').value =
                            valueToSend;
                        setFiltersAppliedModal(filtersAppliedModal);
                        break;
                    }
            }
        }

        if (
            filtersAppliedModal !== null &&
            filtersAppliedModal !== undefined &&
            filterName !== ''
        ) {
            let filterServiceName = '';
            switch (filterName) {
                case 'fecha-ipo-desde':
                    filterServiceName = 'IPODateFrom';
                    break;

                case 'fecha-ipo-hasta':
                    filterServiceName = 'IPODateTo';
            }

            let update_temp = false;
            for (let element in filtersAppliedModal) {
                if (filtersAppliedModal[element].filterName === filterName) {
                    // si el filtro ya existe, actualiza los valores del mismo.
                    filtersAppliedModal[element].value = valueToSend;
                    filtersAppliedModal[element]['filterServiceName'] =
                        filterServiceName;
                    update_temp = true;
                    break;
                }
            }
            if (!update_temp && filterName.length > 0)
                // si el fltro no se agrego previamente, agrega el filtro al array..
                filtersAppliedModal.push({
                    filterName: filterName,
                    value: valueToSend,
                    filterServiceName: filterServiceName,
                });
            setFiltersAppliedModal(filtersAppliedModal);
        }
    };
    const onChangeFilterfechaipodesde = target => {
        if (filtersLoad) return;

        var filterName = 'fecha-ipo-desde';
        var valueToSend = target;
        var fechaDesde = target;
        var fechaHasta = '';

        filtersAppliedModal.forEach(element => {
            if (element.filterName === 'fecha-ipo-hasta')
                fechaHasta = element.value;
        });

        if (fechaDesde !== '' && fechaHasta !== '') {
            fechaDesde = fechaDesde.split('/');
            fechaHasta = fechaHasta.split('/');
            if (
                fechaDesde[3] > fechaHasta[3] ||
                (fechaDesde[2] === fechaHasta[2] &&
                    fechaDesde[1] > fechaHasta[1]) ||
                (fechaDesde[2] === fechaHasta[2] &&
                    fechaDesde[1] === fechaHasta[1] &&
                    fechaDesde[0] > fechaHasta[0])
            ) {
                for (let i = 0; i < filtersAppliedModal.length; i++)
                    if (
                        filtersAppliedModal[i].filterName === 'fecha-ipo-hasta'
                    ) {
                        valueToSend =
                            fechaDesde[0] +
                            '/' +
                            fechaDesde[1] +
                            '/' +
                            fechaDesde[2];
                        filtersAppliedModal[i].value =
                            fechaDesde[0] +
                            '/' +
                            fechaDesde[1] +
                            '/' +
                            fechaDesde[2];
                        document.querySelector('#fecha-ipo-hasta').value =
                            valueToSend;
                        setFiltersAppliedModal(filtersAppliedModal);
                        break;
                    }
            }
        }
        if (
            filtersAppliedModal !== null &&
            filtersAppliedModal !== undefined &&
            filterName !== ''
        ) {
            let filterServiceName = '';
            switch (filterName) {
                case 'fecha-ipo-desde':
                    filterServiceName = 'IPODateFrom';
                    break;

                case 'fecha-ipo-hasta':
                    filterServiceName = 'IPODateTo';
                    break;
            }

            let update_temp = false;
            for (let element in filtersAppliedModal) {
                if (filtersAppliedModal[element].filterName === filterName) {
                    // si el filtro ya existe, actualiza los valores del mismo.
                    filtersAppliedModal[element].value = valueToSend;
                    filtersAppliedModal[element]['filterServiceName'] =
                        filterServiceName;
                    update_temp = true;
                    break;
                }
            }
            // si el fltro no se agrego previamente, agrega el filtro al array..
            if (!update_temp && filterName.length > 0)
                filtersAppliedModal.push({
                    filterName: filterName,
                    value: valueToSend,
                    filterServiceName: filterServiceName,
                });
            setFiltersAppliedModal(filtersAppliedModal);
        }
    };

    const onChangeFilterfechaVencihasta = target => {
        if (filtersLoad) return;

        var filterName = 'fecha-venci-hasta';
        var valueToSend = target;
        var fechaDesde = '';
        var fechaHasta = target;

        filtersAppliedModal.forEach(element => {
            if (element.filterName === 'fecha-venci-desde')
                fechaDesde = element.value;
        });

        if (fechaDesde !== '' && fechaHasta !== '') {
            fechaDesde = fechaDesde.split('/');
            fechaHasta = fechaHasta.split('/');
            if (
                fechaDesde[3] > fechaHasta[3] ||
                (fechaDesde[2] === fechaHasta[2] &&
                    fechaDesde[1] > fechaHasta[1]) ||
                (fechaDesde[2] === fechaHasta[2] &&
                    fechaDesde[1] === fechaHasta[1] &&
                    fechaDesde[0] > fechaHasta[0])
            ) {
                for (let i = 0; i < filtersAppliedModal.length; i++)
                    if (
                        filtersAppliedModal[i].filterName ===
                        'fecha-venci-hasta'
                    ) {
                        valueToSend =
                            fechaDesde[0] +
                            '/' +
                            fechaDesde[1] +
                            '/' +
                            fechaDesde[2];
                        filtersAppliedModal[i].value =
                            fechaDesde[0] +
                            '/' +
                            fechaDesde[1] +
                            '/' +
                            fechaDesde[2];
                        document.querySelector('#fecha-venci-hasta').value =
                            valueToSend;
                        setFiltersAppliedModal(filtersAppliedModal);
                        break;
                    }
            }
        }
        if (
            filtersAppliedModal !== null &&
            filtersAppliedModal !== undefined &&
            filterName !== ''
        ) {
            let filterServiceName = '';
            switch (filterName) {
                case 'fecha-venci-desde':
                    filterServiceName = 'ExpirationDateFrom';
                    break;

                case 'fecha-venci-hasta':
                    filterServiceName = 'ExpirationDateTo';
                    break;
            }

            let update_temp = false;
            for (let element in filtersAppliedModal) {
                if (filtersAppliedModal[element].filterName === filterName) {
                    // si el filtro ya existe, actualiza los valores del mismo.
                    filtersAppliedModal[element].value = valueToSend;
                    filtersAppliedModal[element]['filterServiceName'] =
                        filterServiceName;
                    update_temp = true;
                    break;
                }
            }
            // si el fltro no se agrego previamente, agrega el filtro al array..
            if (!update_temp && filterName.length > 0)
                filtersAppliedModal.push({
                    filterName: filterName,
                    value: valueToSend,
                    filterServiceName: filterServiceName,
                });
            setFiltersAppliedModal(filtersAppliedModal);
        }
    };
    const onChangeFilterfechaVencidesde = target => {
        if (filtersLoad) return;

        var filterName = 'fecha-venci-desde';
        var valueToSend = target;
        var fechaDesde = target;
        var fechaHasta = '';

        filtersAppliedModal.forEach(element => {
            if (element.filterName === 'fecha-venci-hasta')
                fechaHasta = element.value;
        });

        if (fechaDesde !== '' && fechaHasta !== '') {
            fechaDesde = fechaDesde.split('/');
            fechaHasta = fechaHasta.split('/');
            if (
                fechaDesde[3] > fechaHasta[3] ||
                (fechaDesde[2] === fechaHasta[2] &&
                    fechaDesde[1] > fechaHasta[1]) ||
                (fechaDesde[2] === fechaHasta[2] &&
                    fechaDesde[1] === fechaHasta[1] &&
                    fechaDesde[0] > fechaHasta[0])
            ) {
                for (let i = 0; i < filtersAppliedModal.length; i++)
                    if (
                        filtersAppliedModal[i].filterName ===
                        'fecha-venci-hasta'
                    ) {
                        valueToSend =
                            fechaDesde[0] +
                            '/' +
                            fechaDesde[1] +
                            '/' +
                            fechaDesde[2];
                        filtersAppliedModal[i].value =
                            fechaDesde[0] +
                            '/' +
                            fechaDesde[1] +
                            '/' +
                            fechaDesde[2];
                        document.querySelector('#fecha-venci-hasta').value =
                            valueToSend;
                        setFiltersAppliedModal(filtersAppliedModal);
                        break;
                    }
            }
        }

        if (
            filtersAppliedModal !== null &&
            filtersAppliedModal !== undefined &&
            filterName !== ''
        ) {
            let filterServiceName = '';
            switch (filterName) {
                case 'fecha-venci-desde':
                    filterServiceName = 'ExpirationDateFrom';
                    break;
                case 'fecha-venci-hasta':
                    filterServiceName = 'ExpirationDateTo';
                    break;
            }

            let update_temp = false;
            for (let element in filtersAppliedModal) {
                if (filtersAppliedModal[element].filterName === filterName) {
                    // si el filtro ya existe, actualiza los valores del mismo.
                    filtersAppliedModal[element].value = valueToSend;
                    filtersAppliedModal[element]['filterServiceName'] =
                        filterServiceName;
                    update_temp = true;
                    break;
                }
            }
            if (!update_temp && filterName.length > 0)
                filtersAppliedModal.push({
                    filterName: filterName,
                    value: valueToSend,
                    filterServiceName: filterServiceName,
                });
            setFiltersAppliedModal(filtersAppliedModal);
        }
    };

    const onChangeFilterMarca = target => {
        if (filtersLoad) return;

        var update = false;
        var _optSelectMarcaSelect = JSON.parse(
            JSON.stringify(optSelectMarcaSelect)
        );
        var i = 0;
        for (i = 0; i < _optSelectMarcaSelect.length; i++) {
            if (parseInt(_optSelectMarcaSelect[i]) === parseInt(target)) {
                update = true;
                _optSelectMarcaSelect.splice(i, 1);
                setoptSelectMarcaSelect(_optSelectMarcaSelect);
                break;
            }
        }
        if (!update) {
            _optSelectMarcaSelect.push(target);
            setoptSelectMarcaSelect(_optSelectMarcaSelect);
        }
    };

    const filterMarca = () => {
        var checkMarca = [];
        var filterMarcaActive = [];
        props.filtersApplied.forEach(valueFilterActive => {
            if (valueFilterActive.filterName === 'MarcaSelected')
                filterMarcaActive = valueFilterActive.value.split(',');
        });
        props.optSelectMarca.forEach(element => {
            checkMarca.push(
                <div
                    className="u-1/1 u-text-left u-float-left u-pb-xsmall"
                    key={element[1]}
                >
                    <label className="c-checkbox pickupCheckbox u-float-left">
                        <input
                            className="c-checkbox__input"
                            type="checkbox"
                            onChange={() => onChangeFilterMarca(element[1])}
                            defaultChecked={
                                filterMarcaActive.length === 0 ||
                                (filterMarcaActive.length > 0 &&
                                    filterMarcaActive.includes(element[1]))
                                    ? true
                                    : false
                            }
                            value={element[1]}
                            id={element[1]}
                        />
                        <span className="c-checkbox__label checkbox-span" />
                    </label>
                    <label className="u-float-left">{element[0]}</label>
                </div>
            );
        });
        return checkMarca;
    };

    return (
        <div className="c-modal">
            <div className="c-modal__overlay js-modal-close"></div>
            <div
                className="c-modal__wrapper modalPosition_FilterMatriz"
                role="dialog"
                aria-labelledby="foo-bar-baz"
            >
                <header
                    className="c-modal__header"
                    style={{
                        padding: '0px',
                        paddingTop: '10px',
                    }}
                >
                    <div className="o-layout__item u-10/12 ">
                        <label className="c-modal__title">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16.5 21"
                            >
                                <path
                                    id="Shape"
                                    d="M5.25,1.5h1.5V12H5.25Zm0,18h1.5v3H5.25ZM6,18a2.25,2.25,0,1,1,2.25-2.25A2.25,2.25,0,0,1,6,18Zm0-3a.75.75,0,1,0,.75.75A.75.75,0,0,0,6,15ZM17.25,1.5h1.5V12h-1.5Zm0,18h1.5v3h-1.5ZM18,18a2.25,2.25,0,1,1,2.25-2.25A2.307,2.307,0,0,1,18,18Zm0-3a.75.75,0,1,0,.75.75A.709.709,0,0,0,18,15Zm-6.75-3h1.5V22.5h-1.5Zm0-10.5h1.5v3h-1.5Zm.75,9A2.307,2.307,0,0,1,9.75,8.25a2.25,2.25,0,0,1,4.5,0A2.307,2.307,0,0,1,12,10.5Zm0-3a.709.709,0,0,0-.75.75.75.75,0,0,0,1.5,0A.709.709,0,0,0,12,7.5Z"
                                    transform="translate(-3.75 -1.5)"
                                    fill="#004666"
                                    fillRule="evenodd"
                                />
                            </svg>
                            <span className="mideltextfilter u-text-brand">
                                Filtros
                            </span>
                        </label>
                    </div>

                    <div className="o-layout__item u-2/12">
                        <button
                            onClick={() => props.setModalFilter(false)}
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Cerrar modal."
                        />
                    </div>
                </header>
                <div
                    className="c-modal__content u-pb u-pt-xsmall"
                    role="document"
                >
                    <div className="filtercontent">
                        <div
                            id="nif_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title is-active"
                            onClick={() => SHOW('nif_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3 className="c-accordion__title">
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    NIF
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="nif_control"
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div
                                    className="input-div"
                                    onChange={onChangeFilter}
                                >
                                    <Input
                                        options={{
                                            id: 'nif',
                                            type: 'text',
                                            placeHolder: 'Introduce un NIF',
                                            autoComplete: 'off',
                                        }}
                                        onChange={() => {}}
                                    />
                                </div>
                            </div>
                        </div>

                        <div
                            id="Vendedor_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                            onClick={() => SHOW('Vendedor_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3 className="c-accordion__title">
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    Asesor original
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="Vendedor_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div
                                    className="input-div"
                                    onChange={onChangeFilter}
                                >
                                    <Input
                                        options={{
                                            id: 'SellerContractsFullName',
                                            type: 'text',
                                            placeHolder:
                                                'Introduce un asesor original',
                                            autoComplete: 'off',
                                        }}
                                        defaultValue=""
                                        onChange={() => {}}
                                    />
                                </div>
                            </div>
                        </div>

                        {checkPermission(
                            'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                        ) && (
                            <div
                                id="Vendedor_Asignado_control_active"
                                className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                                onClick={() =>
                                    SHOW('Vendedor_Asignado_control')
                                }
                            >
                                <span className="c-accordion__title-icon"></span>
                                <h3 className="c-accordion__title">
                                    <button className="c-accordion__title-label  js-accordion__title-label">
                                        Asesor asignado
                                    </button>
                                </h3>
                            </div>
                        )}
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="Vendedor_Asignado_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div
                                    className="input-div"
                                    onChange={onChangeFilter}
                                >
                                    <Input
                                        options={{
                                            id: 'UsuarioVendedorAsignado',
                                            type: 'text',
                                            placeHolder:
                                                'Introduce un asesor asignado',
                                            autoComplete: 'off',
                                        }}
                                        defaultValue=""
                                        onChange={() => {}}
                                    />
                                </div>
                            </div>
                        </div>

                        <div
                            id="matricula_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                            onClick={() => SHOW('matricula_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3 className="c-accordion__title">
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    Matrícula
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="matricula_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div
                                    className="input-div"
                                    onChange={onChangeFilter}
                                >
                                    <Input
                                        options={{
                                            id: 'matricula',
                                            type: 'text',
                                            placeHolder:
                                                'Introduce una matrícula',
                                            autoComplete: 'off',
                                        }}
                                        onChange={() => {}}
                                    />
                                </div>
                            </div>
                        </div>

                        <div
                            id="OpComercial_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                            onClick={() => SHOW('OpComercial_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3 className="c-accordion__title">
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    Producto Comercial
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="OpComercial_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div
                                    className="input-div"
                                    onChange={onChangeFilter_ProductoComerial}
                                >
                                    <OpComercialFilter
                                        setProductoComercial={
                                            setProductoComercial
                                        }
                                        filtersApplied={props.filtersApplied}
                                    />
                                </div>
                            </div>
                        </div>

                        <div
                            id="Fecha_IPO_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                            onClick={() => SHOW('Fecha_IPO_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3
                                className="c-accordion__title"
                                style={{ marginBottom: '0px' }}
                            >
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    Fecha IPO
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="Fecha_IPO_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div>
                                    <span>
                                        <label className="labelConsT u-text-muted u-1/1">
                                            Desde
                                        </label>
                                        <div
                                            className={'fecha-ipo-desde'}
                                            onChange={onChangeFilterTextDate}
                                        >
                                            <DatePicker
                                                options={{
                                                    id: 'fecha-ipo-desde',
                                                    type: 'default',
                                                }}
                                                onChange={
                                                    onChangeFilterfechaipodesde
                                                }
                                            />
                                        </div>
                                    </span>
                                    <span>
                                        <label className="labelConsT u-text-muted u-1/1">
                                            Hasta
                                        </label>
                                        <div
                                            className="fecha-ipo-hasta"
                                            onChange={onChangeFilterTextDate}
                                        >
                                            <DatePicker
                                                options={{
                                                    id: 'fecha-ipo-hasta',
                                                    type: 'date',
                                                }}
                                                onChange={
                                                    onChangeFilterfechaipohasta
                                                }
                                            />
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div
                            id="Fecha_Venci_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                            onClick={() => SHOW('Fecha_Venci_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3
                                className="c-accordion__title"
                                style={{ marginBottom: '0px' }}
                            >
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    Fecha Vencimiento
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="Fecha_Venci_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div>
                                    <span>
                                        <label className="labelConsT u-text-muted u-1/1">
                                            Desde
                                        </label>
                                        <div
                                            className={'fecha-venci-desde'}
                                            onChange={onChangeFilterTextDate}
                                        >
                                            <DatePicker
                                                options={{
                                                    id: 'fecha-venci-desde',
                                                    type: 'default',
                                                }}
                                                onChange={
                                                    onChangeFilterfechaVencidesde
                                                }
                                            />
                                        </div>
                                    </span>
                                    <span>
                                        <label className="labelConsT u-text-muted u-1/1">
                                            Hasta
                                        </label>
                                        <div
                                            className="fecha-venci-hasta"
                                            onChange={onChangeFilterTextDate}
                                        >
                                            <DatePicker
                                                options={{
                                                    id: 'fecha-venci-hasta',
                                                    type: 'date',
                                                }}
                                                className="fecha-venci-hasta"
                                                onChange={
                                                    onChangeFilterfechaVencihasta
                                                }
                                            />
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div
                            id="Modelo_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                            onClick={() => SHOW('Modelo_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3 className="c-accordion__title">
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    Modelo
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="Modelo_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div
                                    className="input-div"
                                    onChange={onChangeFilter}
                                >
                                    <Input
                                        options={{
                                            id: 'VehicleModelDescription',
                                            type: 'text',
                                            placeHolder: 'Introduce un modelo',
                                            autoComplete: 'off',
                                        }}
                                        onChange={() => {}}
                                    />
                                </div>
                            </div>
                        </div>

                        {optSelectMarca.length > 1 && (
                            <div
                                id="Marca_control_active"
                                className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                                onClick={() => SHOW('Marca_control')}
                            >
                                <span className="c-accordion__title-icon"></span>
                                <h3 className="c-accordion__title">
                                    <button className="c-accordion__title-label  js-accordion__title-label">
                                        Marca
                                    </button>
                                </h3>
                            </div>
                        )}
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="Marca_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div>{filterMarca()}</div>
                            </div>
                        </div>

                        <div
                            id="Opefinanciera_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                            onClick={() => SHOW('Opefinanciera_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3 className="c-accordion__title">
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    Operación Financiera
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="Opefinanciera_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div
                                    className="input-div"
                                    onChange={onChangeFilter}
                                >
                                    <Input
                                        options={{
                                            id: 'Opefinanciera',
                                            type: 'text',
                                            placeHolder:
                                                'Introduce una Operación',
                                            autoComplete: 'off',
                                        }}
                                        onChange={() => {}}
                                    />
                                </div>
                            </div>
                        </div>

                        <div
                            id="Bastidor_control_active"
                            className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                            onClick={() => SHOW('Bastidor_control')}
                        >
                            <span className="c-accordion__title-icon"></span>
                            <h3 className="c-accordion__title">
                                <button className="c-accordion__title-label  js-accordion__title-label">
                                    Bastidor
                                </button>
                            </h3>
                        </div>
                        <div
                            className="c-accordion__panel  js-accordion__panel"
                            id="Bastidor_control"
                            style={{ display: 'none' }}
                        >
                            <div className="c-accordion__content c-accordion__content--max-width">
                                <div
                                    className="input-div"
                                    onChange={onChangeFilter}
                                >
                                    <Input
                                        options={{
                                            id: 'bastidor',
                                            type: 'text',
                                            placeHolder:
                                                'Introduce un Bastidor',
                                            autoComplete: 'off',
                                        }}
                                        onChange={() => {}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="o-split u-mt-xsmall">
                        <button
                            className="c-btn c-btn--secondary"
                            style={{ width: '45%' }}
                            onClick={() => props.setModalFilter(false)}
                        >
                            CANCELAR
                        </button>
                        <button
                            className="c-btn"
                            style={{ width: '45%' }}
                            onClick={() => setFilterAply()}
                        >
                            APLICAR FILTROS
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(ModalFilter);
